import { z } from "zod/v4";

import { AgenticLogicPageProductDescriptions } from "../../../descriptions/agentic-logic.describe";
import { assertDescriptions } from "../../../descriptions/types";
import { ShopifyProductGidSchema } from "../../../schemas/shopify-gid";

export const AgenticLogicPageProductSchema = z
  .object({
    productId: ShopifyProductGidSchema.describe(
      AgenticLogicPageProductDescriptions.productId
    ),
    handle: z.string().describe(AgenticLogicPageProductDescriptions.handle),
  })
  .describe(AgenticLogicPageProductDescriptions._schema);
export type AgenticLogicPageProduct = z.infer<
  typeof AgenticLogicPageProductSchema
>;

assertDescriptions<
  typeof AgenticLogicPageProductDescriptions,
  AgenticLogicPageProduct
>();
